/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerDtoSearchResponse } from '../../models/customer-dto-search-response';

export interface SearchCustomers$Params {
  SearchText?: string;
  Top?: number;
  Skip?: number;
  SortBy?: string;
  SortDescending?: boolean;
  ShowInactive?: boolean;
}

export function searchCustomers(http: HttpClient, rootUrl: string, params?: SearchCustomers$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerDtoSearchResponse>> {
  const rb = new RequestBuilder(rootUrl, searchCustomers.PATH, 'get');
  if (params) {
    rb.query('SearchText', params.SearchText, {});
    rb.query('Top', params.Top, {});
    rb.query('Skip', params.Skip, {});
    rb.query('SortBy', params.SortBy, {});
    rb.query('SortDescending', params.SortDescending, {});
    rb.query('ShowInactive', params.ShowInactive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerDtoSearchResponse>;
    })
  );
}

searchCustomers.PATH = '/api/customer';
